var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTransfer = function SvgIconTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M18 9.667H6.333c-.5 0-.833-.333-.833-.833S5.833 8 6.333 8H16l-1.917-1.916a.806.806 0 0 1 0-1.167.806.806 0 0 1 1.167 0l3.333 3.333c.25.25.334.584.167.917-.083.333-.417.5-.75.5M6.333 16.334a.76.76 0 0 1-.583-.25l-3.334-3.333c-.25-.25-.333-.584-.166-.917q.249-.5.75-.5h11.667c.5 0 .833.333.833.833s-.334.834-.834.834H5l1.916 1.916a.806.806 0 0 1 0 1.167.76.76 0 0 1-.583.25"
  })));
};
export default SvgIconTransfer;